import BasketItemsSection from 'components/Checkout/Sections/SddSections/BasketItemsSection/BasketItemsSection';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedBasketItemsSection = withGlobalModals(BasketItemsSection);

export default ConnectedBasketItemsSection;
